import React, { useEffect } from "react";
import { observer } from "mobx-react";
import Hero from "./components/Hero";
import WorkshopGrid from "./components/WorkshopGrid";
import Facilitators from "./components/Facilitators";
import TutorMarquee from "./components/TutorMarquee";
import EnquiryForm from "./components/EnquiryForm";
import Faqs from "./components/Faqs";
import Icons from "./components/Icons";

const Workshops = () => {
  useEffect(() => {
    const scrollToHash = () => {
      const id = window.location.hash.replace("#", "");
      if (!id) return;

      requestAnimationFrame(() => {
        const target = document.getElementById(id);
        if (!target) return;

        window.scrollTo({
          top: target.getBoundingClientRect().top + window.scrollY,
        });
      });
    };

    scrollToHash();
    window.addEventListener("hashchange", scrollToHash);

    return () => window.removeEventListener("hashchange", scrollToHash);
  }, []);

  return (
    <>
      <Icons />
      <a href="#workshops-page" className="skip-link sr-only">
        Skip to main content
      </a>
      <main className="ui pages workshops" id="workshops-page">
        <Hero />
        <WorkshopGrid />
        <Facilitators />
        <TutorMarquee />
        <EnquiryForm />
        <Faqs />
      </main>
    </>
  );
};

export default observer(Workshops);
